import React, { type CSSProperties } from 'react';

import { mapField, friendlyOp } from 'loot-core/src/shared/rules';

import { Text } from '../common/Text';
import { View } from '../common/View';

import { Value } from './Value';

const valueStyle = {
  color: 'var(--color-pillTextHighlighted)',
};

type ConditionExpressionProps = {
  field: unknown;
  op: unknown;
  value: unknown;
  options: unknown;
  prefix?: string;
  style?: CSSProperties;
  inline?: boolean;
};

export function ConditionExpression({
  field,
  op,
  value,
  options,
  prefix,
  style,
  inline,
}: ConditionExpressionProps) {
  return (
    <View
      style={{
        display: 'block',
        maxWidth: '100%',
        color: 'var(--color-pillText)',
        backgroundColor: 'var(--color-pillBackgroundLight)',
        borderRadius: 4,
        padding: '3px 5px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {prefix && <Text>{prefix} </Text>}
      <Text className="text-[var(--color-pillTextHighlighted)]">{mapField(field, options)}</Text>{' '}
      <Text>{friendlyOp(op)}</Text>{' '}
      {!['onbudget', 'offbudget'].includes(
        (op as string)?.toLocaleLowerCase(),
      ) && (
        <Value
          style={valueStyle}
          value={value}
          field={field}
          inline={inline}
          valueIsRaw={['contains', 'doesNotContain', 'matches'].includes(
            op as string,
          )}
        />
      )}
    </View>
  );
}
